<div class="products-grid-container">
  <ng-container *ngFor="let product of products">
    <app-product-card [product]="product"></app-product-card>
  </ng-container>
</div>
